module.exports = __webpack_public_path__ + "static/media/tiktok.ca211715.svg";